import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableMagicLinkInit = loadable(() => import('./MagicLinkInit'), {
  fallback: <LoadingScreen />,
});

export default LoadableMagicLinkInit;
